import * as THREE from 'three'

const colors = [
  { id: 1, name: 'Napa Exclusive', hex: '#343536' },
  { id: 2, name: 'Java', hex: '#759578' },
  { id: 3, name: 'Tan', hex: '#905A3F' },
  { id: 4, name: 'White knight', hex: '#EBE4D2' },
  { id: 5, name: 'Rage', hex: '#9C3D41' },
  { id: 6, name: 'Indigo', hex: '#384651' },
  { id: 7, name: 'Marine', hex: '#255871' },
  { id: 8, name: 'Passion', hex: '#963937' },
  { id: 9, name: 'Black Magic', hex: '#3B3C3D' },
  { id: 10, name: 'Potent', hex: '#9E5F62' },
  { id: 11, name: 'Series_1_4175', hex: '#4E7694' },
  { id: 12, name: 'Series_1_6408', hex: '#1D4067' },
  { id: 13, name: 'Series_1_1452', hex: '#D6BE5D' },
  { id: 14, name: 'Tan', hex: '#6A4B3F' },
  { id: 15, name: 'Tree Bark', hex: '#514A45' },
  { id: 16, name: 'Indigo', hex: '#384651' },
  { id: 17, name: 'Seaweed', hex: '#414E4A' },
  { id: 18, name: 'Night', hex: '#4A4A4A' },
  { id: 19, name: 'Alaska', hex: '#C8B59A' },
  { id: 20, name: 'Whipped Cream', hex: '#D0B897' },
  { id: 21, name: 'Oasis', hex: '#9E8A77' },
  { id: 22, name: 'Sand', hex: '#A3896F' },
  { id: 23, name: 'Oyster', hex: '#9F9687' },
  { id: 24, name: 'Bisque', hex: '#998A75' },
  { id: 25, name: 'Rock', hex: '#4E423F' },
  { id: 26, name: 'Coca', hex: '#71695E' },
  { id: 27, name: 'Vigor', hex: '#785543' },
  { id: 28, name: 'Timber', hex: '#673E3C' },
  { id: 29, name: 'Mocha', hex: '#A68D71' },
  { id: 30, name: 'Berry', hex: '#8A7968' },
  { id: 31, name: 'Plush', hex: '#4D3F3F' },
  { id: 32, name: 'Savannah', hex: '#847858' },
  { id: 33, name: 'Marine', hex: '#255871' },
  { id: 34, name: 'Amazon', hex: '#404D49' },
  { id: 35, name: 'Deep Water', hex: '#425366' },
  { id: 36, name: 'Dark Angel', hex: '#494948' },
  { id: 37, name: 'Eskimo', hex: '#E1CFB4' },
  { id: 38, name: 'Tinge', hex: '#998A75' },
  { id: 39, name: 'Earth', hex: '#CBB699' },
  { id: 40, name: 'Autumn', hex: '#8A5A43' },
  { id: 41, name: 'Equinox', hex: '#673F3D' },
  { id: 42, name: 'Pepper', hex: '#A99178' },
  { id: 43, name: 'Beige', hex: '#7D6F5A' },
  { id: 44, name: 'Ash', hex: '#514944' },
  { id: 45, name: 'Torque', hex: '#949695' },
  { id: 46, name: 'Cloud', hex: '#A19E94' },
  { id: 47, name: 'Portland Grey', hex: '#5A5B5A' },
  { id: 48, name: 'Cold Grey', hex: '#7D7974' },
]

export default colors
